export default "__VITE_ASSET__89c1b7bd__"